import * as Variations from './Variations'
import { HtmlBuilder } from './HtmlBuilder'
import { HtmlCodeFactory } from '../../factories/HtmlCodeFactory'
import { EditorComponentContract } from '../EditorComponentContract'
export class HtmlCode extends EditorComponentContract {
  constructor() {
    super(Variations)
    this.htmlBuilder = HtmlBuilder
    this.factory = new HtmlCodeFactory
  }

  elementIds() {
    return ['id']
  }

  elementClasses() {
    return ['classes']
  }

  elementContents() {
    return ['code']
  }

  elementStyles() {
    return []
  }

  info() {
    return {
      name: 'HtmlCode',
      icon: 'fa-code',
      variations: this.variationsInfo()
    }
  }
}